export default __webpack_public_path__ + "static/media/471.49842744.jpg";